<db-dialog-wrapper [dialog]="this" [width]="'718px'">
  <div class="db-unavailable-dialog">
    <div class="db-unavailable-dialog__header" [innerHTML]="header"></div>
    <div class="db-unavailable-dialog__message">
      <div>
        Contact our <a class='db-link'
                       target="_blank"
                       rel="noopener"
                       [href]="'https://help.10web.io/hc/en-us/requests/new'">customer care</a>
        team to get it fixed ASAP.
      </div>
      <div *ngIf="userSubscription != 'starter'">
        In the meantime, you can download your purchased premium plugin(s).
      </div>
    </div>
    <div *ngIf="userSubscription != 'starter'" class="db-unavailable-dialog-body">
      <div *ngFor="let product of filteredPlugins"
           class="db-product-item db-product-item_view_list plugin">
        <div>
          <label class="db-product-item__logo" >
            <span [ngStyle]="{backgroundImage: 'url(' + product.logo + ')'}"></span>
          </label>

          <label class="db-product-item__main-content">
            <div class="db-product-item__info">
              <div class="db-product-item__info-wrap">
                <div class="db-product-item__title">
                  <span class="title-wrap">{{product.title}}</span>
                </div>
                <div class="db-product-item__description">{{product.description}}</div>
              </div>
            </div>
          </label>
          <div class="db-product-item__actions">
            <div class="display-inline-block" *ngIf="!downloadingProducts[product.productId]">
              <a class="db-link " (click)="downloadPlugin(product.productId, product.title)">DOWNLOAD</a>
            </div>

            <div class="db-product__download-progress" *ngIf="downloadingProducts[product.productId]">
              <db-loading-bar [loading]="true" [progressPercent]="downloadingProducts[product.productId]"></db-loading-bar>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</db-dialog-wrapper>
